<template>
  <div class="Statistic">
    <div class="Statistic-inner">
      <div class="StatisticTitle">Statistics</div>
      <el-table :data="tableData" class="table" v-loading="loading" ref="multipleTable" stripe header-cell-class-name="table-header"
        :header-cell-style="headerStyle" :row-style="rowStyle" @cell-click="handlecell" :cell-style="cellstyle">
        <el-table-column v-for="(item, index) in tableDataItem" :width="item.width" :key="index" :prop="item.prop" align="center"
          :show-overflow-tooltip="true" :label="item.label">
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="query.page"
          :page-sizes="[10, 20, 30, 50]" :page-size="query.size" layout="total, sizes, prev, pager, next" :total="pageTotal">
        </el-pagination>
      </div>
      <!-- 物种弹出框 -->
      <el-dialog :title="speciesTitle" :visible.sync="speciesVisible" top="30vh" width="40%" style="overflow:hidden;">
        <div class="speciesImg">
          <img :src="speciesImg" />
        </div>
        <div class="speciesStatistics">
          <ul>
            <li v-for="(item, key) in speciesItems" :key="key">{{ item.label }}:
              <span class="linkSpan" @click="jump(item.label)">{{ item.numbers }}</span>
            </li>
          </ul>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
let url = {
  specie_relation_count: "species/specie_relation_count", // 物种相关，基因、版本、RNA等数据信息接口开发
};
export default {
  data() {
    return {
      tableDataItem: [
        { prop: "speciesName", label: "Species" },
        { prop: "plnc_db", label: "PLncDB" },
        { prop: "gree_nc", label: "GreeNC" },
        { prop: "cantata_db", label: "CANTATAdb" },
        { prop: "rna_central", label: "RNAcentral" },
        { prop: "ensembl", label: "Ensembl" }
      ],
      tableData: [],
      loading: false,
      pageTotal: 0,
      query: {
        page: 1,
        size: 20
      },
      headerStyle: {
        background: "#F5F9FC",
        fontSize: "16px",
        fontFamily: "PingFang SC",
        fontWeight: "bold",
        color: "#333"
      },
      rowStyle: {
        fontSize: "14px",
        fontFamily: "PingFang SC",
        fontWeight: "400",
        color: "#666"
      },
      // 物种弹出框
      speciesTitle: "",
      speciesVisible: false,
      speciesImg: "",
      speciesItems: [
        { label: "Genome Info", numbers: "v1.0" },
        { label: "lncRNA", numbers: "0" },
        { label: "Gene", numbers: "0" },
        { label: "Validated lncRNA", numbers: "0" },
        { label: "RNA-Seq", numbers: "0" }
      ],
      jumpId: '',
      jumpUrl: ''
    };
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {

      this.http.get('species/specie_statistic', this.query).then(res => {
        if (res.data.code == 200) {
          this.tableData = res.data.data
          this.tableData.forEach(item => {
            item.speciesName = item.species.replace(/_/g, ' ');
          })
          this.pageTotal = res.data.count;
        }
      }).catch(err => {
        this.$message.warning(err.response.data.error.message);
      });
    },
    handleSizeChange(val) {
      this.query.page = 1
      this.query.size = val
      this.getData()

    },
    handleCurrentChange(val) {
      this.query.page = val
      this.getData()
    },
    handlecell(row, col) {
      if (col.label === "PLncDB" && row.plnc_db > 0) {
        this.handleNodeClick(row)
        // this.$router.push({
        //   path: "/SpeciesDetail",
        //   query: {
        //     speciesName: row.species,
        //     isSpecie: 'lncRNA'
        //   }
        // });
      } else if (col.label === "GreeNC" && row.gree_nc > 0) {
        window.open(`http://greenc.sciencedesigners.com/wiki/Main_Page`, '_blank')
      } else if (col.label == 'RNAcentral' && row.rna_central > 0) {
        window.open(`https://rancentral.com/`, '_blank')
      } else if (col.label == 'CANTATAdb' && row.cantata_db > 0) {
        window.open(`http://cantata.amu.edu.pl/`, '_blank')
      } else if (col.label == 'Ensembl' && row.ensembl > 0) {
        window.open(`https://plants.ensembl.org/index.html`, '_blank')
      }
    },
    cellstyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1 && row.plnc_db > 0) {
        return { color: '#3366CC', cursor: 'pointer', textDecoration: 'underline' }
      } else if (columnIndex === 2 && row.gree_nc > 0) {
        return { color: '#3366CC', cursor: 'pointer', textDecoration: 'underline' }
      } else if (columnIndex === 3 && row.cantata_db > 0) {
        return { color: '#3366CC', cursor: 'pointer', textDecoration: 'underline' }
      } else if (columnIndex === 4 && row.rna_central > 0) {
        return { color: '#3366CC', cursor: 'pointer', textDecoration: 'underline' }
      } else if (columnIndex === 5 && row.ensembl > 0) {
        return { color: '#3366CC', cursor: 'pointer', textDecoration: 'underline' }
      }
      if (column.label === 'Species') {
        return {
          fontStyle: 'italic'
        }
      }
    },
    // 物种弹出框
    specie_relation_count(label) {
      let params = {
        specie_name: label
      }
      this.jumpUrl = ''
      this.http.get(url.specie_relation_count, params).then(res => {
        if (res.data.code == 200) {
          this.speciesItems = [
            { label: "Genome Info", numbers: res.data.data[0].assembly },
            { label: "lncRNA", numbers: res.data.data[0].lncRNAs },
            { label: "Gene", numbers: res.data.data[0].Genes },
            { label: "Validated lncRNA", numbers: res.data.data[0].Var_lncRNAs },
            { label: "RNA-Seq", numbers: res.data.data[0].Run_IDs }
          ]
          this.jumpUrl = res.data.data[0].link
        }
      }).catch(err => {
        console.log(err);
      });
    },
    handleNodeClick(data) {
      if (data.species) {
        this.jumpId = data.species
        this.speciesTitle = data.species.replace(/_/g, ' ');
        this.speciesVisible = true;
        this.speciesImg = require("@/assets/img/" + data.species + ".jpg");
        this.specie_relation_count(data.species)
      }
    },
    jump(val) {
      if (val === 'Genome Info') {
        val = 'lncRNA'
      }
      this.$router.push({
        path: "/SpeciesDetail",
        query: {
          speciesName: this.jumpId,
          isSpecie: val
        }
      });
    },
  }
};
</script>

<style scoped>
.Statistic {
  width: 100%;
  padding: 30px 0px;
  background: #f5f9fc;
}
.Statistic .Statistic-inner {
  width: 1240px;
  height: auto;
  padding: 0px 20px;
  padding-bottom: 20px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 1);
}
.Statistic .Statistic-inner .StatisticTitle {
  height: 50px;
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 50px;
  border-bottom: 1px solid rgba(229, 233, 235, 1);
  margin-bottom: 20px;
}
.el-pagination {
  /* float: right; */
  text-align: right;
  height: 20px;
  margin: 20px 0;
}
.Statistic /deep/ .el-dialog {
  overflow: hidden !important;
  padding-bottom: 20px;
}
.el-dialog__header {
  padding: 20px 20px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
}

.el-dialog__body {
  overflow: hidden;
  padding: 20px 20px;
}
.el-dialog__body .speciesImg {
  margin: 0;
  padding: 0;
  float: left;
  width: 20%;
  height: 100%;
}
.el-dialog__body .speciesImg img {
  width: 100%;
}

.el-dialog__body .speciesStatistics {
  margin: 0;
  padding: 0;
  float: left;
  width: 80%;
  height: 100%;
}
.el-dialog__body ul {
  list-style: none;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.el-dialog__body ul li {
  margin: 0;
  padding: 0;
  float: left;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 200%;
  width: 50%;
}
.el-dialog__body ul li:first-child {
  width: 100%;
}
.speciesStatistics .linkSpan {
  color: #2291f7;
  cursor: pointer;
  text-decoration: underline;
}
</style>
